import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/logo-safetypoint.png';
import { useCarrito } from '../context/CarritoContext';
import { useNotificaciones } from '../context/NotificacionesContext';
import './Menu.css';

function Menu({ usuario, setUsuario }) {
  const { obtenerCantidadTotal } = useCarrito();
  const { pedidosNuevos, cotizacionesNuevas } = useNotificaciones();
  const [menuAbierto, setMenuAbierto] = useState(false);

  const cerrarMenu = () => setMenuAbierto(false);

  const totalNotificaciones = pedidosNuevos + cotizacionesNuevas;

  return (
    <nav className="menu">
      {/* Logo a la izquierda */}
      <div className="menu-left">
        <img src={logo} alt="Safety Point" />
      </div>

      {/* Botón hamburguesa para móviles */}
      {usuario && (
        <button 
          className="menu-hamburger" 
          onClick={() => setMenuAbierto(!menuAbierto)}
          aria-label="Menú"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      )}

      {/* Menú centrado */}
      {usuario && (
        <ul className={`menu-links ${menuAbierto ? 'menu-abierto' : ''}`}>
          <li><Link to="/" onClick={cerrarMenu}>Inicio</Link></li>
          <li><Link to="/ventas" onClick={cerrarMenu}>Ventas</Link></li>
          <li><Link to="/inventario" onClick={cerrarMenu}>Inventario</Link></li>
          <li>
            <Link to="/pedidos" onClick={cerrarMenu} style={{position: 'relative'}}>
              Pedidos
              {totalNotificaciones > 0 && (
                <span style={{
                  position: 'absolute',
                  top: '-8px',
                  right: '-12px',
                  background: '#e74c3c',
                  color: '#fff',
                  borderRadius: '50%',
                  width: '20px',
                  height: '20px',
                  fontSize: '11px',
                  fontWeight: 'bold',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  animation: 'pulse 2s infinite'
                }}>
                  {totalNotificaciones}
                </span>
              )}
            </Link>
          </li>
          <li><Link to="/reportes" onClick={cerrarMenu}>Reportes</Link></li>
          <li><Link to="/cotizaciones" onClick={cerrarMenu}>Cotizaciones</Link></li>
          <li><Link to="/usuarios" onClick={cerrarMenu}>Usuarios</Link></li>
          <li>
            <Link to="/carrito" onClick={cerrarMenu}>
              Carrito {obtenerCantidadTotal() > 0 && `(${obtenerCantidadTotal()})`}
            </Link>
          </li>
          <li className="menu-mobile-logout">
            <button onClick={() => { setUsuario(null); cerrarMenu(); }}>
              Cerrar sesión
            </button>
          </li>
        </ul>
      )}

      {/* Botón Cerrar sesión a la derecha (solo desktop) */}
      {usuario && (
        <div className="menu-right">
          <button
            onClick={() => setUsuario(null)}
            className="logout-button"
          >
            Cerrar sesión
          </button>
        </div>
      )}

      {/* Overlay para cerrar menú en móvil */}
      {menuAbierto && <div className="menu-overlay" onClick={cerrarMenu}></div>}
    </nav>
  );
}

export default Menu;
